'use strict';

import { Weather } from './Weather';
import { CLOUDS } from '../../liveAnimations/litemode/sky/Sky';
import { OrbitDayAndNight } from '../../liveAnimations/DayNight/OrbitDayAndNight';

export class CloudsShader {

    constructor (weatherData) {
        this.weatherData = weatherData;
        this.active = false;
    }

    enable() {
        let preset;

        if (Weather.checkedCurrentWeather()) {
            preset = this.#getCloudsPreset();
        } else {
            preset = {clouds: {preset: 50 } };
        }

        const cloudsParams = CLOUDS[preset.clouds.preset];
        OrbitDayAndNight.sky.material.uniforms.cloudsCover.value = cloudsParams.cover;
        OrbitDayAndNight.sky.material.uniforms.cloudsAlpha.value = cloudsParams.alpha;
        OrbitDayAndNight.sky.material.uniforms.showClouds.value = true;
        this.active = true;
    }

    disable() {
        OrbitDayAndNight.sky.material.uniforms.showClouds.value = false;
        this.active = false;
    }

    #getCloudsPreset() {

        const data = {};

        if (this.weatherData.hasOwnProperty('clouds')) {
            const cloudsDensity = this.weatherData.clouds.all;
            data.clouds = {};

            if (cloudsDensity === 0){
                data.clouds.preset =  0;
            } else if (cloudsDensity > 0 && cloudsDensity <= 10) {
                data.clouds.preset = 10;
            } else if (cloudsDensity > 10 && cloudsDensity <= 20) {
                data.clouds.preset = 20;
            } else if (cloudsDensity > 20 && cloudsDensity <= 30) {
                data.clouds.preset = 30;
            } else if (cloudsDensity > 30 && cloudsDensity <= 40) {
                data.clouds.preset = 40;
            } else if (cloudsDensity > 40 && cloudsDensity <= 50) {
                data.clouds.preset = 50;
            } else if (cloudsDensity > 50 && cloudsDensity <= 60) {
                data.clouds.preset = 60;
            } else if (cloudsDensity > 60 && cloudsDensity <= 70) {
                data.clouds.preset = 70;
            } else if (cloudsDensity > 70 && cloudsDensity <= 80) {
                data.clouds.preset = 80;
            } else if (cloudsDensity > 80 && cloudsDensity < 100) {
                data.clouds.preset = 90;
            } else  {
                data.clouds.preset = 100;
            }
        } else {
            data.clouds.preset = 0;
        }

        data.wind = this.weatherData.wind;

        return data;
    }

    update() {

    }

}